import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {LoggedUser} from '../../common/logged-user.service';
import {TenantsService} from '../../services/tenants.service';
import {ThemingService} from '../../services/theming.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopBarComponent implements OnInit {

  @Output() openCloseMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

  public userData: any;
  public icon: string;

  private tenant: string;
  private isMenuOpen: boolean = true;


  constructor(private oauthService: OAuthService,
              private themingService: ThemingService,
              private tenantsService: TenantsService,
              private loggedUser: LoggedUser) {
  }

  ngOnInit(): void {
    this.loggedUser.userObservable.subscribe(user => {
      this.userData = user;
    });
    this.loggedUser.userPreferences.subscribe(userData => {
      try {
        const preferences = JSON.parse(userData.preferences);
        this.icon = preferences.icon;
        this.tenant = userData.tenant;
      } catch (e) {
        this.icon = undefined;
      }
    });
  }

  logout(): void {
    this.oauthService.logOut();
  }

  public switchMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.openCloseMenu.emit(this.isMenuOpen);
  }

}
